<template>
  <el-sub-menu :index="menu?.name" :class="`menu-folder ${!isChildren ? 'no-children' : ''}`" @click="handleClick">
    <template #title>
      <menu-icon class="q-pr-sm" :menu="menu" />
      <menu-title :menu="menu" v-show="!collapse" />
    </template>

    <template v-for="it in menu.children || []" :key="`mf_${it.name}`">
      <menu-folder-sub v-if="it?.isFolder" :menu="it" :collapse="collapse"></menu-folder-sub>
      <menu-item v-else :menu="it" :collapse="collapse">{{ it.folderName }}</menu-item>
    </template>
  </el-sub-menu>
</template>

<script setup lang="ts">
import { computed, ref, useHostAppInstance } from '@zto/zpage'
import { ElementPlusIcons } from '@zto/zpage-ui-element'

import { fetchFavItems } from '../../../../utils/fav'

import MenuFolderSub from './menu-folder-sub.vue'
import MenuItem from './menu-item.vue'

import MenuIcon from './menu-icon.vue'
import MenuTitle from './menu-title.vue'

const props = withDefaults(
  defineProps<{
    menu?: any
    collapse?: boolean
  }>(),
  {
    collapse: false
  }
)

const emit = defineEmits(['remove', 'click'])

const app = useHostAppInstance()

const dropdownRef = ref<any>()

const currentMenu = computed(() => {
  return props.menu || []
})

const isFolder = computed(() => {
  return currentMenu.value.isFolder === true
})

const isChildren = computed(() => {
  return !!props.menu.children?.length
})

async function handleClick() {
  const menu = props.menu

  if (!menu) return
  if (menu.children?.length) return
}
</script>

<style lang="scss" scoped>
.menu-folder {
  :deep(.el-sub-menu__title) {
    padding-right: 40px;
  }

  &.no-children {
    :deep(.el-sub-menu__icon-arrow) {
      display: none;
    }

    :deep(.el-sub-menu__title) {
      padding-right: 20px;
    }
  }
}
</style>
